import type { SceneControl } from '@anov/3d-core'
import { Object3D, Vector3, use } from '@anov/3d-core'
import { EWeatherType } from './utils/type'
import { SkySystem } from './sky'
import { WeatherSystem as WeatherLayer } from './weather'
import { handleTimeString } from './utils/math'

/**
 * 天气时间系统
 * base version
 */
export class DynamicWeatherSystem extends Object3D {
  private _time = '08:00'
  private _weather: string

  public skyLayer: SkySystem
  public weatherLayer: WeatherLayer
  private _weatherRoot: Object3D = new Object3D()
  private sceneControl: SceneControl

  public get time() {
    return this._time
  }

  public set time(time: string) {
    this.setTime(time)
  }

  public get weather() {
    return this._weather
  }

  public set weather(weather: string) {
    this.setWeather(weather)
  }

  constructor(sceneControl: SceneControl) {
    super()
    this.sceneControl = sceneControl

    this.skyLayer = new SkySystem()
    this.weatherLayer = new WeatherLayer(undefined, sceneControl)

    this.add(this.skyLayer)
    this.add(this.weatherLayer)

    this.skyLayer.setTime(handleTimeString(this._time))
    this.weatherLayer.setWeather(EWeatherType.Sunny, this._time.split(':').map(Number)[0])
    use.useframe(this.sceneControl, () => {
      const { camera } = use.useScene(this.sceneControl)

      // 假设天空中心在 (0,0,0)，你可以改成其他场景中心点
      const skyCenter = new Vector3(0, 0, 0)
      const distance = camera.position.distanceTo(skyCenter)

      const minDistance = 10 // 太近不显示
      const maxDistance = 8500 // 太远不显示

      // this.skyLayer.updateSky(camera)
      // 根据距离决定显示
      if (distance > maxDistance) {
        this._weatherRoot.position.lerp(camera.position, 0.3)
        const scale = distance * 0.000135
        this.weatherLayer.scale.setScalar(scale)
      }
      else {
        this.weatherLayer.scale.setScalar(1)
        this.skyLayer.scale.setScalar(1)
      }
    })
  }

  setTime(time: string) {
    this._time = time

    this.skyLayer.setTime(handleTimeString(time))
    this.weatherLayer.setTime(time.split(':').map(Number)[0])
  }

  setWeather(weather: string) {
    this._weather = weather
    this.weatherLayer.setWeather(weather, this._time.split(':').map(Number)[0])
  }
}